import { ClientApi } from '@/api/ClientApi';

export async function prefetchClientsSilently() {
    ClientApi.fetchAll()
}